var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-form-checkbox',{staticClass:"no-highlight",attrs:{"switch":""},model:{value:(_setup.currentValue),callback:function ($$v) {_setup.currentValue=$$v},expression:"currentValue"}},[_vm._v("\n    "+_vm._s(_setup.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }